export const DEFAULT_LOGO = '/def/logo.svg';
export const DEFAULT_CARD_BG = '/def/card-bg.svg';
export const DEFAULT_CARD_ICON = '/def/card-icon.svg';

export function resolveImageUrl(url, fallback) {
  if (!url || url === 'null' || url === 'undefined') return fallback;
  return url;
}

const cacheBustVersions = new Map();

/** Сброс кэша браузера после перезаписи файла по тому же URL */
export function withCacheBust(url, { force = false } = {}) {
  if (!url || url.startsWith('blob:') || url.startsWith('/def/')) return url;
  const [base, query] = url.split('?');
  if (!force && query?.includes('v=')) return url;
  if (force || !cacheBustVersions.has(base)) {
    cacheBustVersions.set(base, Date.now());
  }
  return `${base}?v=${cacheBustVersions.get(base)}`;
}

export function invalidateCacheBust(url) {
  const base = url?.split('?')[0];
  if (base) cacheBustVersions.delete(base);
}

export function isDefaultCardBg(url) {
  if (!url || url === 'null' || url === 'undefined') return true;
  if (url.startsWith('blob:')) return false;
  const base = url.split('?')[0];
  return base === DEFAULT_CARD_BG || base.includes('/def/card-bg');
}

export function isTemplateUploadImage(url) {
  if (!url || url === 'null') return false;
  if (url.startsWith('blob:')) return true;
  return url.split('?')[0].includes('/templates/');
}

export function isStoreRegistrationBg(url) {
  if (!url || url === 'null') return false;
  const base = url.split('?')[0];
  if (base.includes('/templates/') || base.includes('/def/')) return false;
  return base.includes('/images/');
}

export function getTemplateImageUrl(url) {
  if (!url || url === 'null' || isDefaultCardBg(url)) return null;
  if (isStoreRegistrationBg(url)) return null;
  if (isTemplateUploadImage(url)) return url;
  if (url.startsWith('blob:')) return url;
  return null;
}
